export default {
    'en': 'English',
    'pl': 'Polski',
    'ru': 'Русский',
    'th': 'ไทย',
    'FIWE_FEVER': 'Expo FEVER',
    'EXPERIENCE': 'Experience Jusfit EMS at',
    'FIWE': 'Asia Fitness Conference',
    'DATE': 'Bangkok, 11.10.2019-13.10.2019<br> Justfit stand: B14',
    'YOUTUBE_TEXT': 'Watch video on YouTube',
    'SAVE_IT': 'SAVE 5,000 EUR and skyrocket your EMS business',
    'JUSTFIT_LITE_PRICE': 'Top EMS product Justfit Pro+ with multiuser option available for the price of a wired system',
    'CONCEPT': 'With Justfit Pro+ you not only get a product, but also become member of the Justfit Mentorship Program, enabling you to enjoy our business and technological support.',
    'SYSTEM': 'Justfit Pro+ is an open system prepared to multiuser option. Further extensions are provided for an extremely good price.',
    'SERVICE': 'Thai representation, service and support are provided.',
    'CUSTOMIZED_PRODUCT': 'Get customized product configuration and business construction according to your needs.',
    'APPOINTMENT': 'Think of tomorrow and save an appointment to experience Justfit at Asia Fitness Conference:',
    'INTERESTED': "Yesss, I’m interested!",
    'JUSTFIT_EXPERIENCE': 'EXPERIENCE JUSTFIT AT Asia Fitness Conference',
    'TRAININGS': 'Participate in single or group training.',
    'TRAININGS_TEXT': 'Hourly trial sessions are held at our stand between 10 am and 4 pm - Hall IV. stand 4.20. Sign up below and secure your spot!',
    'PRESENTATION': 'Ask for a personal product demo',
    'PRESENTATION_TEXT': 'Sign up below for a personal product demo and get to know the exceptional business opportunities.',
    'FORM_TITLE': 'SECURE YOUR SPOT',
    'FORM_TEXT': 'Sign up for a Justfit trial session or a personal product demo by filling out the form below. We look forward to see you at our stand B14.',
    'CONTACT_TEXT': 'Should you have any questions, please feel free to contact us:',
    'YOUR_NAME': 'Name',
    'EMAIL': 'Email',
    'MESSAGE': 'Message',
    'SUBMIT_TEXT': 'Send request',
	"SENT_FORM": "Thank you for registration, we look forward to see you!",
    "ERROR_SENT_FORM": "Something went wrong, please try again",
    'TRAINING_TYPE': 'I’m interested in single and group trial sessions',
    'PRESENTATION_TYPE': 'I’m interested in the personal product demo',
    'PREFERRED_DAY': 'Preferred day of visit:',
    'DAY_1': 'Friday 11. 10',
    'DAY_2': 'Saturday 12. 10',
    'DAY_3': 'Sunday 13. 10.',
    'PREFERRED_TIME': 'Preferred time of visit:',
    'TIME_1': '8.00-11.00 am',
    'TIME_2': '11.00 am-2.00 pm',
    'TIME_3': '2.00 pm-6 pm',
    'AGREE': 'I have read and accepted the <a class="font-style-italic font-weight-semibold" target="_blank" href="https://justfitart.com/images/privacypolicy.pdf">Privacy Policy</a>.',
    'YOU_NEED_TO_AGREE': 'You need to agree the privacy policy',
    'LINK_TO_PRODUCT': 'Secure your discounted product by clicking here',
    'JUSTFITPRO_PRICE': 'Justfit Pro+ only <span class="font-weight-heavy fs-40">12,500</span> EUR at Asia Fitness Conference <br> <span class="font-weight-normal fs-14">(Save 5,000 EUR now)</span>',
}
